import api from './api';

// 菜单类型
export interface Menu {
  id: string;
  parentId: string | null;
  name: string;
  path: string;
  icon: string;
  permission: string;
  type: number; // 1-目录 2-菜单 3-按钮
  sort: number;
  visible: number;
  status: number;
  component: string;
  redirect: string;
  isExternal: number;
  isCache: number;
  remark: string;
  createdAt: string;
  updatedAt: string;
  children?: Menu[];
}

// 创建菜单请求
export interface CreateMenuRequest {
  parentId?: string | null;
  name: string;
  path?: string;
  icon?: string;
  permission?: string;
  type: number;
  sort?: number;
  visible?: number;
  status?: number;
  component?: string;
  redirect?: string;
  isExternal?: number;
  isCache?: number;
  remark?: string;
}

export interface SyncFrontendMenuRequest {
  key: string;
  name: string;
  path?: string;
  icon?: string;
  permission?: string;
  sort?: number;
  children?: SyncFrontendMenuRequest[];
}

// 更新菜单请求
export interface UpdateMenuRequest {
  parentId?: string | null;
  name?: string;
  path?: string;
  icon?: string;
  permission?: string;
  type?: number;
  sort?: number;
  visible?: number;
  status?: number;
  component?: string;
  redirect?: string;
  isExternal?: number;
  isCache?: number;
  remark?: string;
}

// 获取菜单树
export const getMenuTree = (refresh = false) => {
  return api.get<Menu[]>('/menus', { params: refresh ? { refresh: 'true' } : {} });
};

export const getCurrentMenuTree = () => {
  return api.get<Menu[]>('/menus/current');
};

// 获取所有菜单（平铺）
export const getAllMenus = () => {
  return api.get<Menu[]>('/menus/all');
};

// 获取菜单详情
export const getMenu = (id: string) => {
  return api.get<Menu>(`/menus/${id}`);
};

// 创建菜单
export const createMenu = (data: CreateMenuRequest) => {
  return api.post<Menu>('/menus', data);
};

// 更新菜单
export const updateMenu = (id: string, data: UpdateMenuRequest) => {
  return api.put<Menu>(`/menus/${id}`, data);
};

// 删除菜单
export const deleteMenu = (id: string) => {
  return api.delete(`/menus/${id}`);
};

// 清除菜单缓存
export const clearMenuCache = () => {
  return api.post('/menus/clear-cache');
};

export const syncFrontendMenus = (menus: SyncFrontendMenuRequest[]) => {
  return api.post('/menus/sync-frontend', { menus });
};

// 菜单类型映射
export const menuTypeMap: Record<number, { text: string; color: string }> = {
  1: { text: '目录', color: 'blue' },
  2: { text: '菜单', color: 'green' },
  3: { text: '按钮', color: 'orange' },
};

// 图标列表
export const iconList = [
  'DashboardOutlined',
  'SearchOutlined',
  'EyeOutlined',
  'HeartOutlined',
  'MedicineBoxOutlined',
  'ExportOutlined',
  'SettingOutlined',
  'UserOutlined',
  'TeamOutlined',
  'HomeOutlined',
  'ApartmentOutlined',
  'FileTextOutlined',
  'BellOutlined',
  'SafetyOutlined',
  'DatabaseOutlined',
  'CloudOutlined',
  'ToolOutlined',
  'AppstoreOutlined',
  'MenuOutlined',
  'ProfileOutlined',
  'BookOutlined',
  'FileSearchOutlined',
  'FileOutlined',
  'FolderOutlined',
  'ClockCircleOutlined',
  'FundOutlined',
  'WalletOutlined',
  'InboxOutlined',
];
